// extracted by mini-css-extract-plugin
module.exports = {"avatar":"lead-avatar__avatar___3RJk_","number":"lead-avatar__number___1Kwsy"};